export default (objects: string): string => `
-- THESE ARE ALL OF THE CONTENT ITEMS (emails, ads, social media posts, blog posts, etc.) IN THE CURRENTLY SHOWING CONTENT PACKAGE --
${objects}
`;